import React, { useState } from 'react';
import './index.css';
import clsx from 'classnames';
import QueueAnim from 'rc-queue-anim';

const Enterprise = () => {
  const [active, setActive] = useState('1');
  const enterpriseItems = [
    {
      id: '1',
      name: '人员优势',
      icon: '/images/enterprise1.png',
      activeIcon: '/images/enterpriseActive1.png',
      desc: '公司骨干均为检测行业资深专家，拥有十余年行业从业经历，曾主导或参与国家质检中心、重点实验室技术攻关和实验室运营管理等工作，在所属领域具有丰富的检测经验和管理经验，体现扎实的人员基础。',
    },
    {
      id: '2',
      name: '设备优势',
      icon: '/images/enterprise2.png',
      activeIcon: '/images/enterpriseActive2.png',
      desc: '严选行业头部品牌的高精度、高稳定性检测设备，从源头上保障检测数据的精确、可靠。',
    },
    {
      id: '3',
      name: '服务优势',
      icon: '/images/enterprise3.png',
      activeIcon: '/images/enterpriseActive3.png',
      desc: '推行点对点、一对一的定制化服务模式，全程跟进客户委托项目，确保高效闭环完成；实时响应报告疑问，提供专业解答。',
    },
    {
      id: '4',
      name: '营销优势',
      icon: '/images/enterprise4.png',
      activeIcon: '/images/enterpriseActive4.png',
      desc: '采用开放式市场化运作机制与全员营销模式，既保持市场响应的灵活性，又充分激活团队积极性，构建富有活力的营销体系。',
    },
  ];

  const onSelect = (value) => {
    setActive(value);
  };

  const activeItem = enterpriseItems.find((item) => item.id === active);
  return (
    <div className={clsx('enterprise')}>
      <div className={clsx('enterprise-title')}>企业实力</div>
      <div className={clsx('enterprise-content')}>
        <div className={clsx('enterprise-content-left')}>
          {enterpriseItems.map((item, index) => (
            <div
              className={clsx('enterprise-content-left-item', {
                bg: active === item.id,
                mask: active === item.id,
              })}
              key={index}
              onClick={() => onSelect(item.id)}
            >
              <div className={clsx('enterprise-content-left-item-mask')} />
              <div className={clsx('enterprise-content-left-item-icon')}>
                <img
                  src={item.id === active ? item.activeIcon : item.icon}
                  alt=''
                />
              </div>
              <div
                className={clsx('enterprise-content-left-item-name', {
                  isActive: active === item.id,
                })}
              >
                {item.name}
              </div>
            </div>
          ))}
        </div>
        <div className={clsx('enterprise-content-right')}>
          <div className={clsx('enterprise-content-right_mask')} />
          <QueueAnim
            animConfig={[
              { opacity: [1, 0], translateY: [0, 80] },
              { opacity: [1, 0], translateY: [0, 80] },
            ]}
            duration={1000}
          >
            {activeItem
              ? [
                  <div
                    key={activeItem?.id}
                    className={clsx('enterprise-content-right-content-item')}
                  >
                    <div
                      className={clsx('enterprise-content-right-content-title')}
                    >
                      {activeItem?.name}
                    </div>
                    <div
                      className={clsx('enterprise-content-right-content-desc')}
                    >
                      {activeItem?.desc}
                    </div>
                  </div>,
                ]
              : null}
          </QueueAnim>
        </div>
      </div>
      <div className={clsx('enterprise-content-small')}>
        <div className={clsx('enterprise-content-small-content')}>
          {enterpriseItems.map((item, index) => (
            <div key={index} style={{ transition: 'all 0.5s' }}>
              <div
                className={clsx('enterprise-content-small-content-item', {
                  bg: active === item.id,
                  mask: active === item.id,
                  // 单独底部显示desc
                  activeItem: active === item.id,
                })}
                onClick={() => onSelect(item.id)}
              >
                <div className={clsx('enterprise-content-left-item-mask')} />
                <div className={clsx('enterprise-content-left-item-icon')}>
                  <img
                    src={item.id === active ? item.activeIcon : item.icon}
                    alt=''
                  />
                </div>
                <div
                  className={clsx('enterprise-content-left-item-name', {
                    isActive: active === item.id,
                  })}
                >
                  {item.name}
                </div>
              </div>
              {active === item.id && (
                <div
                  className={clsx(
                    'enterprise-content-small-content-item-active',
                  )}
                >
                  {activeItem?.desc}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Enterprise;
